export class Utils {
  static passwordValidate(str: string) {
    if (!str) {
      return false;
    }
    // tslint:disable-next-line: max-line-length
    return str.match(
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[\.\,\[\]\:\'\"\|\\\/{}<>$@!%*#?&+×÷_()^%=;?`~-])[A-Za-z\d\.\,\[\]\:\'\"\|\\\/{}<>$@!%*#?&+×÷_()^%=;?`~-]{6,}$/
    );
  }

  static getWeightToFixed(num: number) {
    // 소수점 5자리에서 반올림
    return Math.round(num * 10000) / 10000;
  }

  static getUSDToFixed(num: number) {
    // 소수점 3자리에서 반올림 (1.265 => 1.27)
    return Math.round(num * 100) / 100;
    // 소수점 3자리에서 절하 (1.269 => 1.26)
    // return Math.floor(num * 100) / 100;
    // 소수점 3자리에서 절상 (1.261 => 1.27)
    // return Math.ceil(num * 100) / 100;
  }

  // static getKRW2USD(currencyRate: CurrencyRate, priceKRW: number) {
  //   if (!priceKRW) return 0;
  //   // 소수점 3자리에서 반올림 (1.265 => 1.27)
  //   return Math.round((priceKRW / currencyRate.krw) * currencyRate.usd * 100) / 100;
  // }

  // static getUSD2KRW(currencyRate: CurrencyRate, priceUSD: number) {
  //   if (!priceUSD) return 0;
  //   // 소수점 반올림
  //   return Math.round((priceUSD * currencyRate.krw) / currencyRate.usd);
  // }

  static getPointToFixed(num: number) {
    // 소수점 3자리에서 반올림 (1.265 => 1.27)
    return Math.round(num * 100) / 100;
  }

  static toNumber(num: any) {
    return Number.parseInt(num, 0);
  }

  static toArray(value: any) {
    if (value) {
      if (Array.isArray(value)) {
        return value;
      } else {
        return [value];
      }
    } else {
      return [];
    }
  }

  static toFloat(num: any) {
    return Number.parseFloat(num);
  }
}
